import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import EnergyBillDetailScreen from './screens/EnergyBillDetailScreen';
import EnergyBillInvoiceDetailScreen from './screens/EnergyBillInvoiceDetailScreen';
import EnergyBillListScreen from './screens/EnergyBillListScreen';

EnergyBill.propTypes = {};

function EnergyBill(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<EnergyBillListScreen />} />
          <Route path=":stationId" element={<EnergyBillInvoiceDetailScreen />} />
          {/* <Route path=":stationId/detail/:billId" element={<EnergyBillInvoiceDetailScreen />} /> */}
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default EnergyBill;
